import { render } from "./EmailDetail.vue?vue&type=template&id=5343fd50&scoped=true"
import script from "./EmailDetail.vue?vue&type=script&lang=js"
export * from "./EmailDetail.vue?vue&type=script&lang=js"

import "./EmailDetail.vue?vue&type=style&index=0&id=5343fd50&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5343fd50"]])

export default __exports__